import { getProducts, getProductsExpositors, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from '../hooks/gets';
import _ from 'lodash'
export const productInOutlet = async (product) => {
    const outlets = await getProductsOutlet()
    const productFilterOutlet = _.filter(outlets.data, ['RefSuelto', product.RefSuelto])[0]
    if (productFilterOutlet !== undefined && productFilterOutlet.Estado.indexOf('VER') > -1) {
        return productFilterOutlet
    }
    const promoA = await getProductsPromoA()
    const productFilterPromoA = _.filter(promoA.data, ['RefSuelto', product.RefSuelto])[0]
    if (productFilterPromoA !== undefined && productFilterPromoA.Estado.indexOf('VER') > -1) {
        return productFilterPromoA
    }
    const promoB = await getProductsPromoB()
    const productFilterPromoB = _.filter(promoB.data, ['RefSuelto', product.RefSuelto])[0]
    if (productFilterPromoB !== undefined && productFilterPromoB.Estado.indexOf('VER') > -1) {
        return productFilterPromoB
    }
    const promoC = await getProductsPromoC()
    const productFilterPromoC = _.filter(promoC.data, ['RefSuelto', product.RefSuelto])[0]
    if (productFilterPromoC !== undefined && productFilterPromoC.Estado.indexOf('VER') > -1) {
        return productFilterPromoC
    }
}